import type { Epic } from 'Flux/index.js'
import { orderSlice } from 'Flux/Slice/Order/OrderSlice.js'
import { authenticationExpiredOr } from 'Framework/Epic/AuthenticationExpired.js'
import { catchError, filter, mergeMap, of } from 'rxjs'

export const AddSampleMetaDatasEpic: Epic = (action$, state$, { [orderSlice.name]: order, OrderRepository }) =>
  action$.pipe(
    filter(order.uploadSampleMetaDataRequest.match),
    mergeMap((action) =>
      OrderRepository.addSampleMetaDatas(action.payload.orderId, action.payload.sampleMetaDatas).pipe(
        mergeMap((response) => of(order.uploadSampleMetaDataSuccess(response))),
        catchError((error) =>
          authenticationExpiredOr({
            error,
            failedRequest: action.type,
            failureAction: of(order.uploadSampleMetaDataFailure({ error }))
          })
        )
      )
    )
  )
